export default __webpack_public_path__ + "static/Montserrat-SemiBold-53b31a44d4132debc087cf7d43aeb531.woff2";